import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/Tables/CustomTable";
import { MoreVertical } from "lucide-react";
import DropdownMenu from "../../ui/DropdownMenu";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import {
  fetchPaidBagsAsync,
  setSelectedActiveBag,
} from "../../../redux/features/requestManagementSlice";
import { useNavigate } from "react-router-dom";

const PaidBagsTable = ({ isActive, startDate, endDate }: any) => {
  const { paidBags, loading } = useAppSelector((state) => state.requests);
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const columns = [
    { label: "S/N", field: "index" },
    { label: "Buyer Name", field: "buyerName" },
    { label: "Buyer Email", field: "buyerEmail" },
    { label: "Vendor Name", field: "vendorName" },
    { label: "Total Items", field: "totalItems" },
    { label: "Total Amount (₦)", field: "totalAmount" },
    { label: "Date Created", field: "createdAt" },
    { label: "Action", field: "action" },
  ];

  const dropdownOptions = [
    {
      label: "View Bag Details",
      onClick: (item: any) => {
        navigate(`/active-bags/${item?.id}`);
        dispatch(setSelectedActiveBag(item));
      },
      returnAll: true,
    },
  ];

  const tableData = paidBags?.data?.map((bag: any, index: number) => ({
    index: page * pageLimit + index + 1,
    buyerName: bag?.buyerName || "N/A",
    buyerEmail: bag?.buyerEmail || "N/A",
    vendorName: bag?.vendorName || "N/A",
    totalItems: bag?.totalItems || 0,
    totalAmount: bag?.totalAmount
      ? Number(bag.totalAmount).toLocaleString()
      : "0",
    createdAt: bag?.createdAt
      ? moment(bag.createdAt).format("Do MMM YYYY, h:mm a")
      : "-",
    action: (
      <DropdownMenu
        options={dropdownOptions}
        icon={<MoreVertical style={{ cursor: "pointer" }} />}
        item={bag}
      />
    ),
  }));

  useEffect(() => {
    dispatch(
      fetchPaidBagsAsync({
        page: page + 1,
        limit: pageLimit,
        isActive,
        startDate,
        endDate,
      })
    );
  }, [page, pageLimit, dispatch, isActive, startDate, endDate]);

  return (
    <CustomTable
      data={{
        columns,
        rows: tableData,
      }}
      noRecordText="No Shopping Bags Available"
      loading={loading}
      showFooter={true}
      totalPages={paidBags?.meta?.totalPages}
      itemsPerPage={paidBags?.meta?.limit}
      currentPage={page}
      onPageChange={(value: number) => {
        setPage(value);
      }}
      onLimitChange={(value: number) => {
        setPageLimit(value);
        setPage(0);
      }}
    />
  );
};

export default PaidBagsTable;
